// extracted by mini-css-extract-plugin
export var button = "_e6-4";
export var hasDarkBackground = "_e6-7";
export var hasLightBackground = "_e6-6";
export var iconWrapper = "_e6-0";
export var large = "_e6-2";
export var medium = "_e6-1";
export var small = "_e6-5";
export var xsmall = "_e6-3";